import axios from 'axios';

export function useApi(baseURL: string = '/api/v1') {
  return axios.create({ baseURL });
}

export function useApiWithToken(token: string, baseURL: string = '/api/v1') {
  return axios.create({
    baseURL,
    headers: {
      Authorization: `Bearer ${token || 'AUTHORIZATION_NOT_SET'}`,
    },
  });
}
